export default ({ to, next, store, router }) => {
  if (store.getters['user/isTypeAllowed'](to.params.log)) {
    return next();
  }

  return router.push({ name: 'index' });
};
